module.exports = "/img/_/_/_/assets/images/creeper/book/common//44.jpg?b2e7bd82a04f919a89421b89bff2e735";